import { gsap } from "gsap";
import Cookies from "js-cookie";

export function AlertBarController() {
  const alertBar = document.getElementById( "ion-topbar" )
  if ( !alertBar ) return
  const isDismissible = alertBar.getAttribute( "data-dismissible" ) === "true";
  const closeButton = alertBar.querySelector( "button.alert-button" );
  const cookie = "alert-bar-dismissed";
  const hideAlertBar = () => gsap.to( alertBar, {
    height: 0, duration: 0.3, onComplete: () => {
    alertBar.toggleAttribute("data-dismissed", true)
  } });
  const showAlertBar = () =>
    gsap.to( alertBar, { height: "auto", duration: 0.3, delay: 0.3 } );
  const dismissAlertBar = () => {
    Cookies.set( cookie, true, { expires: 1 } )
    hideAlertBar()
  }

  if ( Cookies.get( cookie ) ) {
    alertBar.toggleAttribute("data-dismissed", true)
  } else {
    showAlertBar()
  }

  if ( isDismissible && closeButton ) {
    closeButton.addEventListener('click', () => dismissAlertBar())
  }


}